import { render, staticRenderFns } from "./wenInfo.vue?vue&type=template&id=30617230&scoped=true"
import script from "./wenInfo.vue?vue&type=script&lang=js"
export * from "./wenInfo.vue?vue&type=script&lang=js"
import style0 from "./wenInfo.vue?vue&type=style&index=0&id=30617230&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30617230",
  null
  
)

export default component.exports